// App base URL — used for auth links and campaign invite links.
// In development: https://folktale.local
// In production: https://folktale.io
export const APP_BASE_URL =
  process.env.NEXT_PUBLIC_SHARE_BASE_URL || "https://folktale.io";

export const SIGN_IN_URL = `${APP_BASE_URL}/account/sign-in`;

export const CREATE_CAMPAIGN_URL = `${APP_BASE_URL}/account/sign-in?destination=%2Fpulse%2Fcreate`;
